import React from "react";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Badge from "@amzn/meridian/badge";
import Alert from "@amzn/meridian/alert";
import { IMailInfoProps } from "./definitions";

export const MailInfo: React.FC<IMailInfoProps> = ({ count, text, badgeType, alertType }) => {
    return (
        <Row spacing="none">
            {alertType ? (
                <>
                    <Alert size="small">{text}</Alert>
                </>
            ) : (
                <>
                    <Badge type={badgeType ?? undefined} value={count} maxValue={99} />
                    <Text>{text}</Text>
                </>
            )}
        </Row>
    );
};
